import { useEffect, useState } from "react";
import { Button } from "reactstrap";

const Consolidados = ({
  data,
  getdata,
  cumpleanerosCount,
  rol,
  showCumpleanero,
  setShowCumpleanero,
}) => {
  const [comidasResumen, setComidasResumen] = useState([]);
  const [confirmados, setConfirmados] = useState([]);
  const [selected, setSelected] = useState("");

  const groupByTipoUsers = (data, tipo) => {
    const res = data.filter((data) => {
      if (data?.pre_usuarios?.pre_tipos_usuarios?.code === tipo) {
        return data;
      }
      if (tipo === undefined) {
        return data?.pre_usuarios?.pre_tipos_usuarios?.code === "expatriado";
      }
    });
    return res.length;
  };

  useEffect(() => {
    if (data.length > 0) {
      buildComidasResumen(data);
    } else {
      setComidasResumen([]);
      setConfirmados([]);
      setSelected("");
    }
  }, [data]);

  const getDetalleTipoUusario = async (data, tipo) => {
    const res = await data.filter((data) => {
      if (data?.pre_usuarios?.pre_tipos_usuarios?.code === tipo) {
        return data;
      }
      if (tipo === undefined) {
        return data?.pre_usuarios?.pre_tipos_usuarios?.code === "expatriado";
      }
    });
    setShowCumpleanero(false);
    getdata(res);
  };

  const buildComidasResumen = (rows) => {
    const map = new Map();
    rows.forEach((item) => {
      const comidaName = (item?.comida || "").toString().trim();
      if (!comidaName) return;
      if (!map.has(comidaName)) {
        map.set(comidaName, { nombre: comidaName, total: 0 });
      }
      map.get(comidaName).total += 1;
    });
    setComidasResumen(Array.from(map.values()));
  };

  const getDataBySelected = () => {
    if (selected === "TODOS") return data;
    return data.filter((item) => item.comida === selected);
  };

  useEffect(() => {
    if (!selected) return;
    const selectedData = getDataBySelected();
    const selectedConfirmados = selectedData.filter(
      (item) => item.client_estado === "CONFIRMADO"
    );
    setConfirmados(selectedConfirmados);
    getdata(selectedConfirmados, selected);
    setShowCumpleanero(false);
  }, [selected, data]);

  const getTables = (data) => {
    return (
      <table className="tb w-100">
        <tbody className="w-100">
          <tr className=" w-100 td-consolidado ">
            <td
              className="text-center"
              style={{ float: "center", width: "60%" }}
            >
              Cuadrillas
            </td>
            <td style={{ float: "left" }}>
              {groupByTipoUsers(data, "cuadrilla")}
            </td>
            <td style={{ float: "center" }}>
              {rol === "1" && (
                <button
                  onClick={() => getDetalleTipoUusario(data, "cuadrilla")}
                  className="d-flex justify-content-center align-items-center p-1"
                  style={{ background: "none", borderRadius: "5px" }}
                >
                  <i className="fas fa-eye"></i>
                </button>
              )}
            </td>
          </tr>
          <tr className=" w-100 td-consolidado ">
            {" "}
            <td
              className="text-center"
              style={{ float: "center", width: "60%" }}
            >
              Trabajadores
            </td>
            <td style={{ float: "left" }}>
              {groupByTipoUsers(data, "trabajador")}
            </td>
            <td style={{ float: "center" }}>
              <div className="d-flex justify-content-between align-items-center">
                {rol === "1" && (
                  <button
                    onClick={() => getDetalleTipoUusario(data, "trabajador")}
                    className="d-flex justify-content-center align-items-center p-1"
                    style={{ background: "none", borderRadius: "5px" }}
                  >
                    <i className="fas fa-eye"></i>
                  </button>
                )}
                {cumpleanerosCount > 0 && selected === "TODOS" ? (
                  <Button
                    size="md"
                    style={{
                      background: showCumpleanero ? "#dc3545" : "none",
                      color: showCumpleanero ? "#fff" : "#dc3545",
                      padding: 0,
                      margin: 0,
                      borderRadius: "5px",
                    }}
                    onClick={() => setShowCumpleanero(!showCumpleanero)}
                  >
                    🎂 {cumpleanerosCount}
                  </Button>
                ) : (
                  <span>🎂 {cumpleanerosCount}</span>
                )}
              </div>
            </td>
          </tr>
          <tr className=" w-100 td-consolidado ">
            {" "}
            <td
              className="text-center"
              style={{ float: "center", width: "60%" }}
            >
              Estudiantes
            </td>
            <td style={{ float: "left" }}>{groupByTipoUsers(data, "E")}</td>
            <td style={{ float: "center" }}>
              {rol === "1" && (
                <button
                  onClick={() => getDetalleTipoUusario(data, "E")}
                  className="d-flex justify-content-center align-items-center p-1"
                  style={{ background: "none", borderRadius: "5px" }}
                >
                  <i className="fas fa-eye"></i>
                </button>
              )}
            </td>
          </tr>
          <tr className=" w-100 td-consolidado ">
            {" "}
            <td
              className="text-center"
              style={{ float: "center", width: "60%" }}
            >
              Proveedores
            </td>
            <td style={{ float: "left" }}>{groupByTipoUsers(data, "P")}</td>
            <td style={{ float: "center" }}>
              {rol === "1" && (
                <button
                  onClick={() => getDetalleTipoUusario(data, "P")}
                  className="d-flex justify-content-center align-items-center p-1"
                  style={{ background: "none", borderRadius: "5px" }}
                >
                  <i className="fas fa-eye"></i>
                </button>
              )}
            </td>
          </tr>
          <tr className=" w-100 td-consolidado ">
            {" "}
            <td
              className="text-center"
              style={{ float: "center", width: "60%" }}
            >
              Visitantes
            </td>
            <td style={{ float: "left" }}>{groupByTipoUsers(data, "V")}</td>
            <td style={{ float: "center" }}>
              {rol === "1" && (
                <button
                  onClick={() => getDetalleTipoUusario(data, "V")}
                  className="d-flex justify-content-center align-items-center p-1"
                  style={{ background: "none", borderRadius: "5px" }}
                >
                  <i className="fas fa-eye"></i>
                </button>
              )}
            </td>
          </tr>
          <tr className=" w-100 td-consolidado ">
            {" "}
            <td
              className="text-center"
              style={{ float: "center", width: "60%" }}
            >
              Guardias
            </td>
            <td style={{ float: "left" }}>{groupByTipoUsers(data, "G")}</td>
            <td style={{ float: "center" }}>
              {rol === "1" && (
                <button
                  onClick={() => getDetalleTipoUusario(data, "G")}
                  className="d-flex justify-content-center align-items-center p-1"
                  style={{ background: "none", borderRadius: "5px" }}
                >
                  <i className="fas fa-eye"></i>
                </button>
              )}
            </td>
          </tr>
          <tr className=" w-100 td-consolidado ">
            {" "}
            <td
              className="text-center"
              style={{ float: "center", width: "60%" }}
            >
              SEAFMAN
            </td>
            <td style={{ float: "left" }}>{groupByTipoUsers(data, "S")}</td>
            <td style={{ float: "center" }}>
              {rol === "1" && (
                <button
                  onClick={() => getDetalleTipoUusario(data, "S")}
                  className="d-flex justify-content-center align-items-center p-1"
                  style={{ background: "none", borderRadius: "5px" }}
                >
                  <i className="fas fa-eye"></i>
                </button>
              )}
            </td>
          </tr>
          <tr className=" w-100 td-consolidado ">
            {" "}
            <td
              className="text-center"
              style={{ float: "center", width: "60%" }}
            >
              TRIMARE
            </td>
            <td style={{ float: "left" }}>{groupByTipoUsers(data, "T")}</td>
            <td style={{ float: "center" }}>
              {rol === "1" && (
                <button
                  onClick={() => getDetalleTipoUusario(data, "T")}
                  className="d-flex justify-content-center align-items-center p-1"
                  style={{ background: "none", borderRadius: "5px" }}
                >
                  <i className="fas fa-eye"></i>
                </button>
              )}
            </td>
          </tr>
          {/*  <tr className=" w-100 td-consolidado ">
        {" "}
        <td className="text-center" style={{float:"center",width:"60%"}}>GUARDIA</td>
        <td style={{float:"left"}}>{groupByTipoUsers(data,"G")}</td>

      </tr> */}
          <tr className=" w-100 td-consolidado ">
            {" "}
            <td
              className="text-center"
              style={{ float: "center", width: "60%" }}
            >
              NO identificados
            </td>
            <td style={{ float: "left" }}>
              {groupByTipoUsers(data, undefined)}
            </td>
            <td style={{ float: "center" }}>
              {rol === "1" && (
                <button
                  onClick={() => getDetalleTipoUusario(data, undefined)}
                  className="d-flex justify-content-center align-items-center p-1"
                  style={{ background: "none", borderRadius: "5px" }}
                >
                  <i className="fas fa-eye"></i>
                </button>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row d-flex justify-content-center flex-row align-items-center">
          {comidasResumen.map((item) => (
            <button
              key={item.nombre}
              className="p-2"
              onClick={() => setSelected(item.nombre)}
              style={{ width: "300px" }}
            >
              {item.nombre} TOTALES ({item.total})
            </button>
          ))}
          <button
            className="p-2"
            onClick={() => setSelected("TODOS")}
            style={{ width: "300px" }}
          >
            TOTAL ({data.length})
          </button>
        </div>
        {selected === "" ? (
          <div className="py-5 w-100 d-flex justify-content-center">
            <h3>Seleccione una comida para ver el consolidado</h3>
          </div>
        ) : (
          <div className="row px-1 py-4 d-flex w-100 justify-content-center align-items-center">
            {" "}
            {/*begin::Col*/}
            <div className="col-lg-4 col-6  p-2">
              {" "}
              <div
                onClick={() => getdata(confirmados)}
                className=" d-flex justify-content-center align-items-center  flex-column border shadow bg-white w-100 h-100"
                style={{ background: "none", borderRadius: "5px  " }}
              >
                <div className="inner small-box m-0 bg-success w-100  p-2 text-center ">
                  <h3 className="text-denter">{confirmados.length}</h3>
                  <label>{selected}S CONFIRMADOS</label>
                </div>

                <div className="w-100 px-2">{getTables(confirmados)}</div>
              </div>{" "}
            </div>
            {/*   <div className="col-lg-4 col-6  p-2">
              {" "}
              <div
                onClick={() => getdata(pendientes)}
                className=" d-flex justify-content-center align-items-center  flex-column border shadow bg-white w-100 h-100"
                style={{ background: "none", borderRadius: "5px  " }}
              >
                <div className="inner small-box m-0  w-100 p-2 bg-warning text-center">
                  <h3 className="text-denter">{pendientes.length}</h3>
                  <label>{selected}S PENDIENTES</label>
                </div>
                <div className="w-100 px-2">{getTables(pendientes)}</div>
              </div>{" "}
            </div>
            <div className="col-lg-4 col-6 p-2">
              {" "}
             
              <div
                className=" d-flex justify-content-center align-items-center  flex-column border shadow bg-white w-100 h-100"
                style={{ background: "none", borderRadius: "5px  " }}
              >
                <div className="inner small-box m-0 bg-danger p-2  w-100 text-center">
                  <h3 className="text-denter">{incompletos.length}</h3>
                  <label>{selected}S INCOMPLETOS</label>
                </div>
                <div className="w-100 px-2">{getTables(incompletos)}</div>
              </div>{" "}
              
            </div> */}
            {/*  <div className="col-lg-4 col-6  p-2">
             
              <div
                className=" d-flex justify-content-center align-items-center  w-100 h-100"
                style={{ background: "#1b3765", borderRadius: "5px  " }}
              >
                <div className="inner small-box m-0 m-2 text-center">
                  <h3 className="text-denter">
                    {selected === "ALMUERZO"
                      ? almuerzos.length
                      : merienda.length}
                  </h3>
                  <label>{selected} TOTALES</label>
                </div>
              </div>
            </div> */}
          </div>
        )}
      </div>
    </>
  );
};
export default Consolidados;
